var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCornerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 113,
    viewBox: "0 0 409 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.591 112.541C394.075 109.12 381.563 105.979 376.09 103.7C370.491 101.361 364.661 99.1406 358.834 96.9212C353.341 94.8291 347.851 92.7378 342.556 90.5486C338.611 88.9588 334.954 87.1954 331.286 85.4268C327.572 83.6357 323.847 81.8393 319.8 80.2131C305.56 74.6868 293.259 68.1023 283.364 60.7099C282.863 60.3241 282.385 59.9496 281.92 59.5852C278.353 56.792 275.552 54.5988 269.383 52.5183C264.74 50.9523 259.978 49.7693 255.275 48.601C252.915 48.0147 250.57 47.432 248.262 46.8065C237.03 43.7598 225.575 40.8993 214.111 38.0367C204.324 35.5928 194.531 33.1474 184.865 30.5833C169.862 26.5851 153.429 24.1003 137.052 21.6239C132.196 20.8895 127.344 20.1559 122.536 19.3838C118.019 18.6609 113.522 17.9331 109.037 17.207C87.0127 13.642 65.254 10.12 42.6893 7.44829C29.8695 5.91364 17.3185 3.79237 4.73345 1.66534C3.15636 1.3988 1.57874 1.13216 -7.80695e-06 0.866577L408.591 0.866577V112.541Z",
    fill: "#0C1217"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerRight);
export default __webpack_public_path__ + "static/media/corner_right.36667260602bde80b855aa48191d6e4e.svg";
export { ForwardRef as ReactComponent };